<template>
    <div id="matches-search-container">
        <v-text-field
            v-model="searchTerm"
            id="match-search-input"
            class="search-container"
            append-icon="search"
            label="Search Matches"
            dark
            flat
            solo-inverted
            hide-details
            clearable
            clear-icon="mdi-close-circle-outline"
            @input="search"
        ></v-text-field>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchTerm: null,
        };
    },
    methods: {
        search() {
            this.$store.commit('UI/UPDATE_MATCHES_SEARCH_TERM', this.searchTerm)
        },
    },
};
</script>

<style lang="scss" scoped>
#matches-search-container {
    margin-bottom: 20px;
    ::v-deep .search-container {
        width: 100%;
        flex: initial;
        border: 1px solid var(--font-default-color);
        border-radius: 25px;

        .v-input__slot {
            padding: 0 12px 0 20px;
            background: transparent;
        }

        input,
        .v-label {
            font-size: 1rem;
            color: var(--font-default-color);
            font-weight: normal;
        }

        .v-icon,
        .v-icon:before {
            font-size: 18px;
            color: var(--font-default-color);
        }

        .v-input__control {
            min-height: initial;
        }
    }
}
</style>
